import {Component, Element, h, Listen, Prop} from '@stencil/core';

/**
 * @slot default - Use it to inject your joy-collapse-item
 */
@Component({
    tag: 'joy-collapse',
    styleUrl: 'collapse.scss',
    shadow: true,
})
export class JoyCollapse {
    @Element() host!: HTMLJoyCollapseElement;

    /** Accordion mode allows to open only one item at a time. Default to false */
    @Prop() accordion = false;

    @Listen('joy-collapse-item-open')
    collapseIfNeeded(e: any) {
        if (e.target && !this.host.contains(e.target)) {
            return;
        }

        if (!this.accordion) {
            return;
        }

        Array.from(this.host.querySelectorAll('joy-collapse-item'))
            .filter((item) => item !== e.target)
            .map(async (item) => {
                item.open = false;
                // await item.resetCollapseItemState();
            });
    }

    render() {
        return <slot />;
    }
}
